<template>
  <div class="bg-white p-4 lg:mt-0 md:mt-0 mt-4">
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <div>
        <p>Select Event</p>
        <b-form-select
          v-model="albumName"
          class="mb-4"
          @change="checkEvent('event')"
          :disabled="action == 'Edit'"
        >
          <b-form-select-option :value="null">Select</b-form-select-option>
          <b-form-select-option
            v-for="i in pastEventOptions"
            :value="i._id"
            :label="i.title"
            :key="i._id"
            >{{ i.title }}</b-form-select-option
          >
        </b-form-select>
        <p class="text-red fsize12" v-if="showEventAlreadyExist">
          Gallery for this event already exist
        </p>
        <p>Unique Name</p>
        <b-input
          placeholder="Enter unique name"
          class="mb-4"
          v-model="uniqueName"
          :disabled="action == 'Edit'"
          @change="checkEvent('uniqueName')"
        />
        <p class="text-red fsize12" v-if="showUniqueNameAlreadyExist">
          This unique name already exist
        </p>
        <p>Description</p>
        <el-input
          type="textarea"
          :rows="2"
          placeholder="Please input"
          class="mb-4"
          v-model="albumDescription"
        >
        </el-input>

        <p>Upload Image</p>
        <el-upload
          multiple
          action="#"
          class="upload-demo"
          accept="image/*"
          :file-list="images"
          :on-change="handleOnChange"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          :on-exceed="handleExceed"
        >
          <el-button size="small" type="primary">Click to upload</el-button>
          <div slot="tip" class="el-upload__tip">
            jpg/png files with a size less than 5MB
          </div>
        </el-upload>
        <div
          class="text-sm text-gray-600 font-medium px-2 py-1 mb-1 border rounded bg-gray-100 inline-block"
        >
          Recommended Size: 700px × 400px
        </div>
        <div class="flex justify-center mt-6">
          <b-button
            type="primary"
            native-type="submit"
            variant="primary"
            class="px-10 py-2 mx-1 flex items-center font-semibold"
            @click="handleSubmit"
          >
            Submit</b-button
          >
        </div>
      </div>
    </el-dialog>

    <div class="w-full flex justify-end">
      <b-button
        type="primary"
        native-type="submit"
        variant="primary"
        class="px-2 py-2 mx-1 flex items-center font-semibold"
        @click="
          () => {
            resetForm();
            dialogVisible = true;
          }
        "
      >
        <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>Add</b-button
      >
    </div>
    <div class="mt-8">
      <p class="text-2xl font-semibold text-primary">Events</p>
      <div class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-2 gap-6 mt-6">
        <div v-for="album in albums" :key="album._id">
          <div @click="handleClick(album._id)">
            <div v-if="album.images[0]">
              <img
                :src="`${$imageURL}/${album.images[0]}`"
                alt="img"
                class="w-full h-56 rounded-lg object-contain"
              />
              <p class="text-base font-semibold text-primary">
                Event Name : {{ album.eventName.title }}
              </p>
              <p class="text-base font-semibold text-primary">
                Unique Name : {{ album.uniqueName }}
              </p>
            </div>
            <div v-else>
              <img
                src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
                alt="img"
                class="w-full h-56 rounded-lg object-contain"
              />
              <p class="text-base font-semibold text-primary">
                Event Name : {{ album.eventName.title }}
              </p>
              <p class="text-base font-semibold text-primary">
                Unique Name : {{ album.uniqueName }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import GalleryDetails from "./components/GalleryDetails.vue";
import _ from "lodash";
export default {
  components: {
    GalleryDetails,
  },
  data() {
    return {
      dialogVisible: false,
      albumName: "",
      uniqueName: "",
      albumDescription: "",
      images: [],
      imagesData: [],
      albums: {},
      file: null,
      action: "Add",
      pastEventOptions: [],
      showEventAlreadyExist: false,
      showUniqueNameAlreadyExist: false,
      isEventSelected: false,
    };
  },
  methods: {
    async init() {
      const galleryData = await this.$store.dispatch(
        "gallery/getAllAlbums",
        {}
      );
      this.albums = galleryData.data.albums;
    },
    async checkEvent(check) {
      if (check == "event") {
        this.showEventAlreadyExist = false;
        console.log("FUNC CALLED");
        if (this.eventName != "") {
          this.isEventSelected = true;
          let payload = {
            eventName: this.albumName,
            isDeleted: false,
          };

          const galleryData = await this.$store.dispatch(
            "gallery/getAlbumById",
            payload
          );
          console.log(galleryData, "888");
          if (galleryData.code == 200) {
            console.log(galleryData, "galleryData");
            this.editvalue = galleryData.data.album;
            this.showEventAlreadyExist = true;
            this.action = "Edit";
            this.albumDescription = galleryData.data.album.albumDescription;
            this.uniqueName = galleryData.data.album.uniqueName;
            this.albumName = galleryData.data.album.eventName._id;
          } else {
            this.action = "Add";
            this.albumDescription = "";
            this.uniqueName = "";
            this.albumName = "";
            this.showEventAlreadyExist = false;
          }
        }
      } else if (check == "uniqueName") {
        this.showUniqueNameAlreadyExist = false;
        console.log("FUNC CALLED");
        if (this.uniqueName != "") {
          const galleryData = await this.$store.dispatch(
            "gallery/getAlbumById",
            {
              uniqueName: this.uniqueName,
              isDeleted: false,
            }
          );
          if (galleryData.code == 200) {
            console.log(galleryData, "galleryData");
            this.showUniqueNameAlreadyExist = true;
          } else {
            this.showUniqueNameAlreadyExist = false;
          }
        }
      }
    },
    async getPastEvents() {
      let payload = {
        id: "61e954501a9b68138421810e",
      };
      const data = await this.$store.dispatch(
        "cms/GetPagesbyCategoryForEvent",
        payload
      );
      this.pastEventOptions = data.data[0].past;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `The limit is 3, you selected ${
          files.length
        } files this time, add up to ${files.length + fileList.length} totally`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`Cancel the transfert of ${file.name} ?`);
    },
    handleRemove(file, fileList) {
      const result = _.difference(this.images, [file]);
      // console.log("after : ", result);
      this.images = result;
    },
    handleOnChange(file, fileList) {
      let mByte = 5 * 1048576;
      if (file.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        fileList.pop();
        return;
      } else {
        this.images.push(file);
        const result = _.uniq(this.images, "uid");
        this.images = result;
      }
    },
    handleClose() {
      this.dialogVisible = false;
      if (this.isEventSelected) {
        this.resetForm();
      }
    },
    async handleSubmit() {
      if (this.action == "Add") {
        let FormData = require("form-data");
        let data = new FormData();
        // console.log("Images:", this.images, typeof this.images);
        data.append("eventName", this.albumName);
        data.append("uniqueName", this.uniqueName);
        data.append("albumDescription", this.albumDescription);
        if (this.images && this.images.length !== 0) {
          for (let i = 0; i < this.images.length; i++) {
            data.append("files", this.images[i].raw);
          }
        }
        let loader = this.$loading();
        try {
          const galleryData = await this.$store.dispatch(
            "gallery/createGallery",
            data
          );
          if (galleryData.code == 200) {
            this.dialogVisible = false;
            // this.$router.push({ name: "aboutus-main" });
            this.$swal.fire({
              text: "Your gallery has been successfully created",
              icon: "success",
              confirmButtonText: "Okay",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            });
            loader.close();
            this.resetForm();
            const albums = await this.$store.dispatch(
              "gallery/getAllAlbums",
              {}
            );
            this.albums = albums.data.albums;
            this.imagesData = galleryData.data.gallery.images;
            // console.log("uploaded images :", this.imagesData);
          }
        } catch (error) {
          if (error) {
            loader.close();
          }
        }
      } else if (this.action == "Edit") {
        let data = new FormData();
        data.append("id", this.editvalue._id);
        data.append("albumDescription", this.albumDescription);
        if (this.images && this.images.length !== 0) {
          for (let i = 0; i < this.images.length; i++) {
            data.append("files", this.images[i].raw);
          }
        }
        let loader = this.$loading();
        try {
          const editedGalleryData = await this.$store.dispatch(
            "gallery/editAlbumData",
            data
          );
          if (editedGalleryData.code == 200) {
            this.dialogVisible = false;
            this.$swal.fire({
              text: "Gallery Updated Successfully",
              icon: "success",
              confirmButtonText: "Okay",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            });
            loader.close();
          }
        } catch (error) {
          if (error) {
            loader.close();
            console.log(error);
          }
        }
      }
    },
    resetForm() {
      this.action = "Add";
      this.eventName = null;
      this.albumName = null;
      this.uniqueName = "";
      this.albumDescription = "";
      this.images = [];
      this.showEventAlreadyExist = false;
      this.showUniqueNameAlreadyExist = false;
      this.isEventSelected = false;
      // this.$refs.eventProvider.reset();
      // this.$refs.uniqueNameProvider.reset();
      // this.$refs.descriptionProvider.reset();
    },
    handleClick(id) {
      this.$router.push({ name: "galleryDetails", params: { id: id } });
    },
  },
  mounted() {
    this.init();
    this.getPastEvents();
  },
};
</script>
